/****************************************************
 * Module Name:  tingeProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class TingeProxy {
  static GetAllTinge = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tinge",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleTinge = (tingeId, callback) => {
    let params = {
      id: tingeId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/tinge",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllTingeMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tinge/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };


  static CheckTingeAvailable = (tinge, callback) => {
    let params = {
      tinge: tinge,
    };

    restAPICall(
      Constants.MANAGER_URL + "/tinge/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddTinge = (tinge, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tinge",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(tinge),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateTinge = (tinge, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tinge",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(tinge),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteTinge = (tinge, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/tinge",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(tinge),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
